import React from "react";

export default function Hero() {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/29015508/pexels-photo-29015508.jpeg')",
        }}
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/40" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pt-40 pb-24 min-h-[100svh] flex flex-col justify-center">
        <div className="max-w-3xl fade-up">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-12 h-px bg-[#d4af37]" />
            <span className="text-xs uppercase tracking-[0.3em] text-[#d4af37] font-bold">
              Wollongong · NSW
            </span>
          </div>

          <h1
            data-testid="hero-heading"
            className="font-heading text-white text-6xl sm:text-7xl md:text-8xl lg:text-9xl leading-[0.85] uppercase"
          >
            Full
            <br />
            Circle
            <br />
            <span className="text-[#d4af37]">MMA</span>
          </h1>

          <p className="mt-8 text-base md:text-lg text-white/75 max-w-xl leading-relaxed">
            Built for fighters. Open to everyone. Train striking and grappling under
            one roof, shaped by over 2 decades of mat time on the Illawarra.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="#membership"
              data-testid="hero-cta-join"
              className="inline-flex items-center px-8 py-4 bg-[#d4af37] text-black text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#f1c40f] transition-colors btn-lift"
            >
              Join The Gym
            </a>
            <a
              href="#booking"
              data-testid="hero-cta-private"
              className="inline-flex items-center px-8 py-4 border border-white/30 text-white text-xs font-bold uppercase tracking-[0.2em] hover:border-[#d4af37] hover:text-[#d4af37] transition-colors"
            >
              Book Private Session
            </a>
          </div>
        </div>

        {/* Bottom info strip */}
        <div className="absolute left-0 right-0 bottom-0 border-t border-white/10 bg-black/60 backdrop-blur-md">
          <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 grid grid-cols-2 md:grid-cols-4 gap-6 text-xs uppercase tracking-[0.18em]">
            <div>
              <div className="text-[#d4af37] font-bold">Striking</div>
              <div className="text-white/60 mt-1">Mon · Thu</div>
            </div>
            <div>
              <div className="text-[#d4af37] font-bold">Grappling</div>
              <div className="text-white/60 mt-1">Wed · Fri</div>
            </div>
            <div>
              <div className="text-[#d4af37] font-bold">Sparring</div>
              <div className="text-white/60 mt-1">Tuesday</div>
            </div>
            <div>
              <div className="text-[#d4af37] font-bold">Private</div>
              <div className="text-white/60 mt-1">30 · 45 · 60 min</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
